module.exports = __webpack_public_path__ + "static/media/podcast_asset_template.264ddc15.psd";